import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { careers, applyEmail, HIRING_PAUSED } from "../data/careers";

export default function Careers() {
  return (
    <section
      id="careers"
      data-testid="careers-section"
      className="scroll-mt-24 bg-[#1C1C19] text-[#F7F5F0] py-24 md:py-40"
    >
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-12 mb-16 md:mb-20">
          <div className="md:col-span-3 reveal">
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#F2C14E]">
              (06) · Careers
            </span>
            <div className="mt-6 w-12 h-px bg-[#F2C14E]" />
          </div>
          <div className="md:col-span-9 reveal">
            <h2 className="font-display text-4xl sm:text-5xl lg:text-7xl font-light tracking-tight leading-[1.05]">
              Come build
              <br />
              <span className="italic text-[#729B79]">with us.</span>
            </h2>
            <p className="mt-8 max-w-2xl text-base md:text-lg font-light text-[#F7F5F0]/70">
              We're building a network of exceptional specialists across
              strategy, creative, brand and growth. Project-based, senior-led
              and built around ambitious businesses.
            </p>
          </div>
        </div>

        {HIRING_PAUSED ? (
          <div
            data-testid="careers-paused"
            className="reveal rounded-3xl border border-[#F7F5F0]/15 bg-[#F7F5F0]/[0.03] p-8 md:p-14 max-w-3xl mx-auto text-center"
          >
            <p className="text-base md:text-lg font-light text-[#F7F5F0]/80 leading-relaxed">
              We're not hiring for any specific roles right now. We're always glad
              to hear from exceptional strategists, creatives and growth people
              though. Send us your CV and a short note, and we'll keep it on file
              for when the right project opens up.
            </p>
            <a
              href={`https://mail.google.com/mail/?view=cm&fs=1&to=${applyEmail}&su=${encodeURIComponent(
                "CV / Resume"
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="careers-send-cv"
              className="btn-magnetic mt-8 inline-flex items-center gap-3 px-6 py-4 rounded-full bg-[#F2C14E] text-[#1C1C19] text-xs sm:text-sm normal-case tracking-normal whitespace-nowrap hover:bg-[#F7F5F0]"
            >
              Send us your CV
              <ArrowUpRight size={16} className="shrink-0" />
            </a>
          </div>
        ) : (
          <>
            <div className="grid md:grid-cols-3 gap-6 md:gap-8">
              {careers.map((r, i) => (
                <Link
                  key={r.slug}
                  to={`/careers/${r.slug}`}
                  data-testid={`career-role-${i + 1}`}
                  className="reveal group flex flex-col justify-between rounded-2xl border border-[#F7F5F0]/15 bg-[#F7F5F0]/[0.03] p-8 transition-all duration-500 hover:-translate-y-1 hover:bg-[#F7F5F0]/[0.06]"
                >
                  <div>
                    <span
                      className="inline-block w-2.5 h-2.5 rounded-full"
                      style={{ backgroundColor: r.accent }}
                    />
                    <h3 className="mt-6 font-display text-2xl md:text-3xl font-light tracking-tight leading-tight">
                      {r.title}
                    </h3>
                    <p className="mt-3 text-[11px] uppercase tracking-[0.2em] text-[#F7F5F0]/50">
                      {r.type} · {r.location}
                    </p>
                    <p className="mt-5 text-sm md:text-base font-light text-[#F7F5F0]/70">
                      {r.blurb}
                    </p>
                  </div>
                  <span className="mt-8 inline-flex items-center gap-2 text-xs uppercase tracking-widest text-[#F7F5F0]/80 group-hover:text-[#F7F5F0]">
                    View role
                    <ArrowUpRight
                      size={15}
                      className="transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1"
                    />
                  </span>
                </Link>
              ))}
            </div>

            <div className="mt-16 flex flex-col sm:flex-row items-start sm:items-center gap-4 reveal">
              <p className="text-sm font-light text-[#F7F5F0]/60">
                Don't see your role? Introduce yourself anyway.
              </p>
              <a
                href={`https://mail.google.com/mail/?view=cm&fs=1&to=${applyEmail}&su=Introduction`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="careers-general-cta"
                className="btn-magnetic inline-flex items-center gap-3 px-6 py-4 rounded-full border border-[#F7F5F0]/40 text-xs sm:text-sm normal-case tracking-normal whitespace-nowrap hover:bg-[#F7F5F0] hover:text-[#1C1C19]"
              >
                {applyEmail}
                <ArrowUpRight size={16} className="shrink-0" />
              </a>
            </div>
          </>
        )}
      </div>
    </section>
  );
}
